import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '@mui/material/Pagination';

import * as taskRedux from '../redux/TaskRedux';
import TaskTable from './TaskTable';

function GiantTable() {
  const dispatch = useDispatch();
  const tasks = useSelector(taskRedux.giantTasksSelector);
  const count = useSelector(taskRedux.giantTasksCountSelector);
  const status = useSelector(taskRedux.giantTasksStatusSelector);
  const page = useSelector(taskRedux.giantTasksPageSelector);

  useEffect(() => {
    dispatch(taskRedux.actions.retrieveGiantTasks());
  }, []);

  function onPageChange(event, page) {
    dispatch(taskRedux.actions.retrieveGiantTasks(page));
  }

  return (
    <div className="card w-100">
      <div className="card-body position-relative" id="kt_not_reachable_body">
        <TaskTable
          tasks={tasks}
          displayOwner={false}
          loading={status === 'loading'}
          onRefresh={() => dispatch(taskRedux.actions.retrieveGiantTasks())}
        />
        {count > 0 && (
          <Pagination
            className="mx-auto mt-4 d-flex justify-content-center"
            count={Math.ceil(count / taskRedux.TASKS_PER_PAGE)}
            page={page}
            onChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
}

export default GiantTable;
